<template>
  <v-container class="pa-0 ma-0 ">
    <v-divider dark="true"></v-divider>
    <v-row no-gutters class="pa-0 ma-0" id="finished_loaded_id">
      <v-col v-if="showAllImportsExportsGraph" lg="6" xs="12" sm="12" md="12" class="pa-0 ma-">
        <exporter-graph-all-market-selection
          ref="allImportsExportsGraph"
          query_type="all_imports_exports"
        />
      </v-col>
      <v-col lg="6" xs="12" sm="12" md="12" class="pa-0 ma-0">
        <exporter-graph-all-market-selection
          ref="reoImportsExportsGraph"
          query_type="reo_imports_exports"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import exporterGraphAllMarketSelection from '@/components/trade-dsm-application/result-components/mpmc-graphs-under-graph/exporter-graph-all-market-selection.vue';
import calc_reo_table_values from '@/components/trade-dsm-application/mixins/calc_reo_table_values';
import {eventBus} from '@/main';
import _ from 'lodash';

export default {
  name: 'mpmc-graphs-importer-exporter',
  mixins: [calc_reo_table_values],
  components: {
    exporterGraphAllMarketSelection,
  },
  data() {
    return {
      showAllImportsExportsGraph: true,
      graphRefreshHandler: null,
      graphRunId: 0,
    };
  },
  mounted() {
    this.graphRefreshHandler = () => {
      this.runGraphs();
    };
    eventBus.$on('TRIGGER_MPMC_IMPORT_EXPORTER_GRAPHS', this.graphRefreshHandler);
    this.$nextTick(() => {
      this.runGraphs();
    });
  },
  beforeDestroy() {
    if (this.graphRefreshHandler !== null) {
      eventBus.$off('TRIGGER_MPMC_IMPORT_EXPORTER_GRAPHS', this.graphRefreshHandler);
    }
  },
  computed: {
    graphInputsReady() {
      if (this.current_report_to_run === '1P1C' || this.$store.state.app.big_map) {
        return false;
      }

      const filtersString = localStorage.getItem('FILTERS');
      const filters = this.$store.state.tradeDSM.dsm_filter_setttings.Filters;
      const meta = filters && filters.META;
      const combinations = meta && meta.combinations;
      const selections = meta && meta.selections;
      const markets = selections && selections.markets && selections.markets.C_Code;
      const products = selections && selections.products && selections.products.HS6_Code;

      return (
        filtersString !== null &&
        combinations &&
        combinations.combinations !== 0 &&
        Array.isArray(markets) &&
        Array.isArray(products) &&
        this.$store.state.app.selectedHomeCountry &&
        this.$store.state.app.selectedModelVersion
      );
    },
  },
  methods: {
    async runGraphs() {
      if (!this.graphInputsReady) {
        this.resetComparisonValues();
        await this.clearGraphs();
        return;
      }

      const runId = ++this.graphRunId;
      this.resetComparisonValues();
      this.showAllImportsExportsGraph = true;
      await this.$nextTick();

      const allGraph = this.$refs.allImportsExportsGraph;
      const reoGraph = this.$refs.reoImportsExportsGraph;

      if (!allGraph || !reoGraph) {
        return;
      }

      const [allData, reoData] = await Promise.all([
        allGraph.loadData(),
        reoGraph.loadData(),
      ]);

      if (runId !== this.graphRunId) {
        return;
      }

      this.setComparisonValues(allData, reoData);
      this.showAllImportsExportsGraph = !this.graphResultsMatch(allData, reoData);
    },
    async clearGraphs() {
      this.showAllImportsExportsGraph = true;
      await this.$nextTick();

      if (this.$refs.allImportsExportsGraph) {
        this.$refs.allImportsExportsGraph.clearData();
      }

      if (this.$refs.reoImportsExportsGraph) {
        this.$refs.reoImportsExportsGraph.clearData();
      }
    },
    resetComparisonValues() {
      this.$store.state.tradeDSM.mpmc_graph_for_comparison_left_vs_right.left_value = [];
      this.$store.state.tradeDSM.mpmc_graph_for_comparison_left_vs_right.right_value = [];
    },
    setComparisonValues(allData, reoData) {
      this.$store.state.tradeDSM.mpmc_graph_for_comparison_left_vs_right.left_value = this.exportSeries(
        allData,
      );
      this.$store.state.tradeDSM.mpmc_graph_for_comparison_left_vs_right.right_value = this.exportSeries(
        reoData,
      );
    },
    graphResultsMatch(allData, reoData) {
      const filters = this.$store.state.tradeDSM.dsm_filter_setttings.Filters;
      const combinations = filters.META.combinations.combinations;
      const reoCombinations =
        filters.META.combinations.reo_summary_values_reo_filtered['Avg6Major__count'];
      const left = this.exportSeries(allData);
      const right = this.exportSeries(reoData);

      return left.length > 0 && reoCombinations === combinations && _.isEqual(left, right);
    },
    exportSeries(graphData) {
      if (
        !graphData ||
        !Array.isArray(graphData.traces) ||
        !graphData.traces[1] ||
        !Array.isArray(graphData.traces[1].y_vals)
      ) {
        return [];
      }

      return _.clone(graphData.traces[1].y_vals).sort();
    },
  },
};
</script>

<style scoped></style>
